var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{staticClass:"btn btn-info",attrs:{"to":_vm.to}},[_vm._t("default",function(){return [_c('i',{staticClass:"fad fa-chevron-left mr-3"}),_vm._v("Zpět ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }